import { T_FUN_FACT } from '~/src/Entities/FunFact/FunFact.Types'

export interface I_FUN_FACT_STATE {
  randomFunFact?: T_FUN_FACT
}

export const INITIAL_STATE: I_FUN_FACT_STATE = {}
